import styleVariables from '@/styles/style.module.scss';
import { ComponentType, ForwardRefExoticComponent, MutableRefObject, RefAttributes } from 'react';
import { ButtonInfo, TabKey } from './provider/state';
import { HistoryItemProps } from './components/History';
import AssociationView from './features/association/AssociationView';
import DeassociationView from './features/deassociation/DeassociationView';
import LedControlView from './features/ledControl/LedControlView';
import MultiAssociationView from './features/multiAssociation/MultiAssociationView';
import OutOfStockView from './features/outOfStock/OutOfStockView';
import { ScannerInputFieldRef } from './components/ScannerInputField';
import RegisterDeviceView from './features/register-device/RegisterDeviceView';
import { StoreSettings } from '@/types/pages/stores';

export type MobileSharedRefs = {
    isSendingRef: MutableRefObject<boolean>;
    eslMacInputRef: MutableRefObject<ScannerInputFieldRef | null>;
};

export type MobileSharedMethods = {
    focusCommonEslInput: () => void;
    playError: () => void;
    playScan: () => void;
    playSuccess: () => void;
    setESL: (val: string) => void;
    setButtonInfo: (status: ButtonInfo) => void;
    addHistoryItem: (item: HistoryItemProps) => void;
};

export type MobileFeatureDependency = {
    settings: Partial<StoreSettings>;
    refs: MobileSharedRefs;
    method: MobileSharedMethods;
};

export type ButtonStatusViewModel = {
    bgColor: string;
    msg: string;
};

export const TAB_CONFIG = [
    { key: 'association', label: 'Association' },
    // { key: 'multi-assoc', label: 'Multi-Assoc' },
    { key: 'deassociation', label: 'Deassociation' },
    // { key: 'out-of-stock', label: 'Stock Control' },
    // { key: 'led-control', label: 'LED' },
    { key: 'register-device', label: 'Register Device' },
];

export const BUTTON_STATUS_VIEW_MAP: Record<ButtonInfo['type'], ButtonStatusViewModel> = {
    idle: {
        bgColor: styleVariables.bgColor1,
        msg: 'Ready',
    },
    loading: {
        bgColor: styleVariables.mobileStatusLoadingBg,
        msg: 'Loading...',
    },
    sending: {
        bgColor: styleVariables.mobileStatusLoadingBg,
        msg: 'Sending Data...',
    },
    success: {
        bgColor: styleVariables.mobileStatusSuccessBg,
        msg: 'Success',
    },
    error: {
        bgColor: styleVariables.mobileStatusErrorBg,
        msg: 'Unknown error occurred',
    },
};
export type MobileFeatureViewProps = {
    dependency: MobileFeatureDependency;
};
export type MobileFeatureHandle = {
    onEslEnter: (value: string) => void;
    onScan: (raw: string) => void;
    onModeChange: () => void;
    onClear?: () => void;
};

export type MobileFeatureComponent = ForwardRefExoticComponent<
    MobileFeatureViewProps & RefAttributes<MobileFeatureHandle>
>;

export enum MOBILE_FLOW_TYPE {
    ESL_PAIRING_FLOW = 'esl-pairing-flow',
    ESL_REGISTRATION_FLOW = 'esl-registration-flow',
}
type EslPairingFlowFeatureConfig = {
    type: MOBILE_FLOW_TYPE.ESL_PAIRING_FLOW;
    component: MobileFeatureComponent;
};

type RegisterFlowFeatureConfig = {
    type: MOBILE_FLOW_TYPE.ESL_REGISTRATION_FLOW;
    component: ComponentType;
};

export type MobileFeatureConfig = EslPairingFlowFeatureConfig | RegisterFlowFeatureConfig;

export const MOBILE_FEATURE_CONFIG: Record<TabKey, MobileFeatureConfig> = {
    association: { type: MOBILE_FLOW_TYPE.ESL_PAIRING_FLOW, component: AssociationView },
    'multi-assoc': { type: MOBILE_FLOW_TYPE.ESL_PAIRING_FLOW, component: MultiAssociationView },
    deassociation: { type: MOBILE_FLOW_TYPE.ESL_PAIRING_FLOW, component: DeassociationView },
    'out-of-stock': { type: MOBILE_FLOW_TYPE.ESL_PAIRING_FLOW, component: OutOfStockView },
    'led-control': { type: MOBILE_FLOW_TYPE.ESL_PAIRING_FLOW, component: LedControlView },
    'register-device': { type: MOBILE_FLOW_TYPE.ESL_REGISTRATION_FLOW, component: RegisterDeviceView },
};
